import React from 'react';
import './ContactUs.css';
import { useEffect } from 'react';
function ContactUs() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); 
  return (
    <div className="contact-container">
      <div className="contact-section">
        <h2 className="contact-heading">Contact Us</h2>
        <p className="contact-paragraph">
          Oxford Convent English Medium School, Khajuri
        </p>
        <p className="contact-paragraph">
          Oxford Convent English Medium School, Aland, Kalaburgi, Karnataka - 585314 
        </p>
        <p className="contact-paragraph">
          Email: <a href="mailto:oxfordconvent2013@gmail.com">oxfordconvent2013@gmail.com</a>
        </p>
        <p className="contact-paragraph">
          Admission Helpline: <a href="tel:+919008680776">+91 9008680776</a>
        </p>
      </div>
    </div>
  );
}

export default ContactUs;
